import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { ArchivalCollection } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  addArchivalCollectionToFavourites,
  removeArchivalCollectionFromFavourites,
} from 'modules/portfolio-favourite/favourite-api';
import { AuthCtx } from 'components/auth/auth-ctx';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalCollectionFavourite({
  item,
  refreshDetail,
}: GridActionButtonComponent) {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);
  const { showNotification } = useContext(NotificationCtx);

  const archivalCollection = item as ArchivalCollection;

  const isFavourite = Boolean(archivalCollection?.favourite);

  const handleAddToFavourites = useCallback(async () => {
    const response = await addArchivalCollectionToFavourites(
      archivalCollection.id
    );

    if (response.ok) {
      showNotification(
        'Archivní fond byl úspěšně přidán mezi oblíbené.',
        NotificationVariant.SUCCESS
      );

      refreshDetail();
    } else {
      showNotification(
        'Při přidávání archivního fondu mezi oblíbené nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalCollection, showNotification, refreshDetail]);

  const handleRemoveFromFavourites = useCallback(async () => {
    const response = await removeArchivalCollectionFromFavourites(
      archivalCollection.id
    );

    if (response.ok) {
      showNotification(
        'Archivní fond byl úspěšně odebrán z oblíbených.',
        NotificationVariant.SUCCESS
      );

      refreshDetail();
    } else {
      showNotification(
        'Při odebíraní archivního fondu z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalCollection, showNotification, refreshDetail]);

  return userInfo?.aisAuthenticated ? (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={isFavourite ? handleRemoveFromFavourites : handleAddToFavourites}
    >
      {isFavourite ? 'Odstraň z oblíbených' : 'Přidej k oblíbeným'}
    </Button>
  ) : (
    <></>
  );
}
